var classes = {"imageActionRoot":"-otTW","imageActionLabel":"JXOdn","imageActionWithoutLabel":"vuNpi"};

export { classes as default };
